import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { useDict } from '../../../contexts/LanguageContext';
import ROUTE_NAME from '../../../routes/RouteName';
import FaqContainer from './FaqContainer';

const GeneralEnquiries = () => {
    const dict = useDict();

    return (
        <FaqContainer
            navigationActive="generalenquiries"
            nextLink={ROUTE_NAME.FAQ_ELIGIBILITY}
            nextTitle={dict.eligibility}
        >
            <Card className="card--not-full-height">
                <CardBody className="documentation__card-body">
                    <div className="card__title">
                        <h3 className="bold-text" style={{ color: '#264391' }}>
                            {dict.generalEnquiries}
                        </h3>
                    </div>
                    <p>
                        <strong>{dict.generalEnquiriesTitle1}</strong>
                    </p>
                    <p>
                        {dict.generalEnquiriesTitle1Text1}
                    </p>
                    <p>
                        {dict.generalEnquiriesTitle1Text2}
                    </p>
                    <p>
                        {dict.generalEnquiriesTitle1Text3}
                    </p>
                    <p>
                        <strong>
                            {dict.generalEnquiriesTitle2}
                        </strong>
                    </p>
                    <p>
                        {dict.generalEnquiriesTitle2Text1}
                    </p>
                    <p>
                        <strong>
                            {dict.generalEnquiriesTitle3}
                        </strong>
                    </p>
                    <p>
                        {dict.generalEnquiriesTitle3Text1}
                    </p>
                    <p>
                        {dict.generalEnquiriesTitle3Text2}
                    </p>
                    <p>
                        {dict.generalEnquiriesTitle3Text3}
                    </p>
                    <p>
                        {dict.generalEnquiriesTitle3Text4}
                    </p>
                    <p>
                        <strong>
                            {dict.generalEnquiriesTitle4}
                        </strong>
                    </p>
                    <p>
                        {dict.generalEnquiriesTitle4Text1}
                    </p>
                    <p>
                        {dict.generalEnquiriesTitle4Text2}
                    </p>
                    <ul>
                        <li>
                            {dict.generalEnquiriesTitle4Text2List1}
                        </li>
                        <li>
                            {dict.generalEnquiriesTitle4Text2List2}
                        </li>
                        <li>
                            {dict.generalEnquiriesTitle4Text2List3}
                        </li>
                        <li>
                            {dict.generalEnquiriesTitle4Text2List4}
                        </li>
                    </ul>
                    <p>
                        <strong>
                            {dict.generalEnquiriesTitle5}
                        </strong>
                    </p>
                    <p>
                        {dict.generalEnquiriesTitle5Text1}
                    </p>
                    <ul>
                        <li>
                            {dict.generalEnquiriesTitle5Text1List1}
                        </li>
                        <li>
                            {dict.generalEnquiriesTitle5Text1List2}
                        </li>
                        <li>
                            {dict.generalEnquiriesTitle5Text1List3}
                        </li>
                        <li>
                            {dict.generalEnquiriesTitle5Text1List4}
                        </li>
                    </ul>
                    <p>
                        <strong>
                            {dict.generalEnquiriesTitle6}
                        </strong>
                    </p>
                    <p>
                        {dict.generalEnquiriesTitle6Text1}
                    </p>
                    <p>
                        {dict.generalEnquiriesTitle6Text2}
                    </p>
                    <p>
                        {dict.generalEnquiriesTitle6Text3}
                    </p>
                    <p>
                        <strong>{dict.generalEnquiriesTitle7}</strong>
                    </p>
                    <p>
                        {dict.generalEnquiriesTitle7Text1}
                    </p>
                    <p>
                        <strong>{dict.generalEnquiriesTitle8}</strong>
                    </p>
                    <p>
                        {dict.generalEnquiriesTitle8Text1}
                    </p>
                    <p>
                        <strong>{dict.generalEnquiriesTitle9}</strong>
                    </p>
                    <p>
                        {dict.generalEnquiriesTitle9Text1}
                    </p>
                    <p>
                        {dict.generalEnquiriesTitle9Text2}
                    </p>
                    <p>
                        <strong>{dict.generalEnquiriesTitle10}</strong>
                    </p>
                    <p>
                        {dict.generalEnquiriesTitle10Text1}
                    </p>
                    <p>
                        <strong>{dict.generalEnquiriesTitle11}</strong>
                    </p>
                    <p>
                        {dict.generalEnquiriesTitle11Text1}
                    </p>
                    <ol>
                        <li>
                            {dict.generalEnquiriesTitle11Text1List1}
                        </li>
                        <li>
                            {dict.generalEnquiriesTitle11Text1List2}
                        </li>
                        <li>
                            {dict.generalEnquiriesTitle11Text1List3}
                        </li>
                        <li>
                            {dict.generalEnquiriesTitle11Text1List4}
                        </li>
                    </ol>
                    <p>
                        <strong>{dict.generalEnquiriesTitle12}</strong>
                    </p>
                    <p>
                        {dict.generalEnquiriesTitle12Text1}
                    </p>
                    <p>
                        {dict.generalEnquiriesTitle12Text2}
                    </p>
                </CardBody>
            </Card>
        </FaqContainer>
    );
};

export default GeneralEnquiries;
